import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle } from "@components";
import "./PolicySocialResponsibiltiy.scss";
import { SocialResponsibiltiyAPI, ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";
import { TitleComponent } from "../../../common/components/TitleComponent";
import { useParams } from "react-router-dom";
import { Accordion, ThumbnailBig } from "../../../common/components";
import MenuSocial from "../MenuSocial";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const PolicySocialResponsibiltiyContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const Img = styled.img`
  width: 100%;
  height: 450px;
  object-fit: cover;
  margin: 0px auto;
  @media (max-width: 768px) {
    height: 300px;
  }
`;

const PolicySocialResponsibiltiy = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(true);

  const { id } = useParams();

  useEffect(() => {
    setisLoading(true);
    loadData();
  }, []);

  const loadData = async function () {
    const { data } = await SocialResponsibiltiyAPI("/kebijakan");    
    setdata(data.data);
    setisLoading(false);
  };
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? "" : data.judulBannerKebijakan}
            desc={isLoading ? "" : data.deskripsiBannerKebijakan}
            img={isLoading ? "" : data.imageBannerDesktopKebijakan}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? "" : data.judulBannerKebijakan}
            desc={isLoading ? "" : data.deskripsiBannerKebijakan}
            img={isLoading ? "" : data.imageBannerMobileKebijakan}
          />
        </Mobile>
      </Container>

      <PolicySocialResponsibiltiyContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            <Desktop>
              <Img className="mb-4" src={data.imageDataDesktopKebijakan} />
            </Desktop>
            <Mobile>
              <Img className="mb-4" src={data.imageDataMobileKebijakan} />
            </Mobile>
            <p
              dangerouslySetInnerHTML={{ __html: data.deskripsiDataKebijakan }}
            ></p>
            {typeof data.BlockDataKebijakan != "undefined" &&
              data.BlockDataKebijakan.length > 0 && (
                <div className="mb-5">
                  <h2 className="mt-5 mb-4 section-title">
                    {data.accordionTitleKebijakan}
                  </h2>

                  <div className="row">
                    {data.BlockDataKebijakan.map((item, index) => {
                      return (
                        <Accordion
                          key={index}
                          title={item.judulAccordionKebijakan}
                        >
                          {item.deskripsiAccordionKebijakan}
                        </Accordion>
                      );
                    })}
                  </div>
                </div>
              )}
          </div>
          <div className="d-none d-lg-block col">
            <MenuSocial active={0} />
          </div>
        </div>
      </PolicySocialResponsibiltiyContainer>
      <FooterSection currentPage={t("KebijakanTanggungJawab")} />
    </div>
  );
};

export default PolicySocialResponsibiltiy;
